import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { environment } from '../../../environments/environment';
import { SeparateTask } from '../../shared/utils/separate-task';
import { DynamicComponentService } from '../../shared/services/dynamic-component.service';
import { EmptyContainerComponent } from '../../shared/components/empty-container/empty-container.component';


@Component({
    selector: 'app-metric-footer',
    templateUrl: './metric-footer.component.html',
    standalone: true,
    imports: []
})
export class MetricFooterComponent implements OnInit {
  constructor(
    private dynamicComponent: DynamicComponentService,
  ) { }

  ngOnInit () {
    if(environment.useMetric){
      if(environment.useMetric.includes('ya')){
        void this.loadMetricMain();
      }
      if(environment.useMetric.includes('ga')){
        void this.loadMetricSecondary();
      }
      if(environment.useMetric.includes('gtag')){
        void this.loadMetricGtag();
      }
    }
  }

  @SeparateTask()
  async loadMetricMain(): Promise<void> {
    const containerRef = this.createEmptyContainer();
    const {LazyMetricMainComponent} = await import('./components/lazy-metric-main/lazy-metric-main.component');
    const component = containerRef.createComponent(LazyMetricMainComponent);
    component.changeDetectorRef.detectChanges();
  }

  @SeparateTask()
  async loadMetricSecondary(): Promise<void> {
    const containerRef = this.createEmptyContainer();
    const {LazyMetricSecondaryComponent} = await import('./components/lazy-metric-secondary/lazy-metric-secondary.component');
    const component = containerRef.createComponent(LazyMetricSecondaryComponent);
    component.changeDetectorRef.detectChanges();
  }

  @SeparateTask()
  async loadMetricGtag(): Promise<void> {
    const containerRef = this.createEmptyContainer();
    const {LazyMetricGtagComponent} = await import('./components/lazy-metric-gtag/lazy-metric-gtag.component');
    const component = containerRef.createComponent(LazyMetricGtagComponent);
    component.changeDetectorRef.detectChanges();
  }

  private createEmptyContainer(): ViewContainerRef {
    const wrapperRef = this.dynamicComponent.createComponent<EmptyContainerComponent>(EmptyContainerComponent);
    return wrapperRef.instance.viewContainerRef;
  }
}
